<template>
  <v-layout row wrap>
    <v-flex xs12 md2 row class="ml-3">
      <v-alert class="mx-4 mt-6" color="#FF9800" dark dense prominent>
        <v-icon left>mdi-database</v-icon>
        <span class="headline">Reports</span>
      </v-alert>

      <v-card
        style="display:block"
        :color="getThemeColor"
        class="mx-4 mt-2 px-2"
        shaped
        elevation="12"
        width="144"
        v-for="(table,tind) in filteredTables"
        :key="tind+Math.random()+Math.random()"
      >
        <v-card-subtitle @click="getTableData(table.value)" style="color:white">{{table.text}}</v-card-subtitle>
      </v-card>
    </v-flex>
    <v-flex xs12 md2 row v-if="showColumns" class="ml-4">
      <div>
        <v-btn
          color="indigo darken-4"
          height="48"
          dark
          @click="getSelectedColumns()"
          v-if="selectedTable"
        >Show {{selectedTable}}</v-btn>

        <v-card loading shaped elevation="12" height="45" class="mt-6" dark v-if="selectedTable">
          <v-alert color="green darken-4" @click="dialog = !dialog">FILTER QUERY</v-alert>
        </v-card>

        <v-card
          dark
          loading
          shaped
          elevation="12"
          class="mt-4"
          width="144"
          height="60"
          v-for="(colData,innt) in tableData"
          :key="innt+Math.random()+Math.random()"
        >
          <v-checkbox
            multiple
            v-model="finalTblData"
            :value="colData"
            class="mx-2"
            :label="colData.colAppearanceText"
          ></v-checkbox>
        </v-card>
      </div>
      <v-dialog v-model="dialog" max-width="700px" persistent>
        <v-card>
          <v-container fluid>
            <v-row align="center">
              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  v-model="queryColumn0"
                  :items="tableData"
                  label="Column Item"
                  item-text="colAppearanceText"
                  item-value="column"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  :items="queryConditions"
                  filled
                  label="Condition"
                  v-model="queryCondition0"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-text-field
                  label="Value(s)"
                  hide-details="auto"
                  class="mb-6"
                  v-model="queryValue0"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-container fluid>
            <v-row align="center">
              <v-radio-group v-model="queryJoinOperator0" row>
                <v-radio class="mx-6" label="AND" color="blue" value="AND" cols="12" sm="4"></v-radio>
                <v-radio class="mx-6" label="OR" color="warning" value="OR" cols="12" sm="4"></v-radio>
              </v-radio-group>
            </v-row>
          </v-container>
          <v-container fluid>
            <v-row align="center">
              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  v-model="queryColumn1"
                  :items="tableData"
                  label="Column Item"
                  item-text="colAppearanceText"
                  item-value="column"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  :items="queryConditions"
                  filled
                  label="Condition"
                  v-model="queryCondition1"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-text-field
                  label="Value(s)"
                  hide-details="auto"
                  class="mb-6"
                  v-model="queryValue1"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-container fluid>
            <v-row align="center">
              <v-radio-group v-model="queryJoinOperator1" row>
                <v-radio class="mx-6" label="AND" color="blue" value="AND" cols="12" sm="4"></v-radio>
                <v-radio class="mx-6" label="OR" color="warning" value="OR" cols="12" sm="4"></v-radio>
              </v-radio-group>
            </v-row>
          </v-container>
          <v-container fluid>
            <v-row align="center">
              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  v-model="queryColumn2"
                  :items="tableData"
                  label="Column Item"
                  item-text="colAppearanceText"
                  item-value="column"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  :items="queryConditions"
                  filled
                  label="Condition"
                  v-model="queryCondition2"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-text-field
                  label="Value(s)"
                  hide-details="auto"
                  class="mb-6"
                  v-model="queryValue2"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-container fluid>
            <v-row align="center">
              <v-radio-group v-model="queryJoinOperator2" row>
                <v-radio class="mx-6" label="AND" color="blue" value="AND" cols="12" sm="4"></v-radio>
                <v-radio class="mx-6" label="OR" color="warning" value="OR" cols="12" sm="4"></v-radio>
              </v-radio-group>
            </v-row>
          </v-container>
          <v-container fluid>
            <v-row align="center">
              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  v-model="queryColumn3"
                  :items="tableData"
                  label="Column Item"
                  item-text="colAppearanceText"
                  item-value="column"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-select
                  :items="queryConditions"
                  filled
                  label="Condition"
                  v-model="queryCondition3"
                ></v-select>
              </v-col>

              <v-col class="d-flex" cols="12" sm="4">
                <v-text-field
                  label="Value(s)"
                  hide-details="auto"
                  class="mb-6"
                  v-model="queryValue3"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text color="primary" @click="dialog = false">Close</v-btn>
            <v-btn text color="primary" @click="prepareQueryFilters()">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-flex xs12 md9 row v-if="showTable">
      <v-card>
        <v-card-title class="mx-4">
          {{selectedTable.toUpperCase()}}
          <v-spacer></v-spacer>
          <v-switch
            v-if="showTable "
            v-model="selectAll"
            label="Select All"
            class="ml-8 mt-4"
            @change="selectAllTableItems()"
          ></v-switch>
          <v-btn
            v-if="(isAdmin || isManager) "
            @click="generateReport()"
            small
            rounded
            color="success"
            dark
            class="mx-4 mt-2"
          >Print</v-btn>
          <v-btn
            v-if="isAdmin"
            rounded
            small
            color="blue"
            class="mt-3 mx-4"
            dark
            @click="printModeClosed()"
          >Refresh</v-btn>
          <v-btn
            v-if="(isAdmin || isManager) "
            @click="openBulkDeleteDialog()"
            small
            rounded
            color="error"
            dark
            class="mx-4 mt-2"
          >Bulk Delete</v-btn>
          <v-btn
            v-if="selectedTable == 'expenses' && isManager "
            @click="openExpensesReceipts()"
            small
            rounded
            color="primary"
            dark
            class="mx-4 mt-2"
          >Expenses Receipts</v-btn>
          <v-btn
            v-if="((selectedTable == 'live_lessons' || selectedTable == 'subjects') && isStaff) || (isAdmin)"
            rounded
            small
            color
            class="mt-3 mx-4"
            dark
            @click="enterData()"
          >Create {{selectedTable}}</v-btn>

          <v-btn
            v-if="isAdmin"
            rounded
            small
            color="warning"
            class="mt-3 mx-4"
            dark
            @click="showBulk()"
          >Bulk Edit</v-btn>

          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="`Search ${selectedTable.toUpperCase()}`"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-dialog v-model="dialog" min-width="900">
          <TableDialog
            :selTable="selTable"
            :tblHeaders="tblHeaders"
            :selData="selData"
            :dropdownItems="dropdownItems"
            @close-dialog="closeDialog()"
          />
        </v-dialog>
        <v-dialog v-model="dialogItem" min-width="900">
          <DatabaseEntryForm
            :selTable="selTable"
            :tblHeaders="tblHeaders"
            :entryEditData="entryEditData"
            :dropdownItems="dropdownItems"
            :saveFormDataPackage="saveFormDataPackage"
            :status="status"
            @close-dialog="closeDialogItem()"
            @data-saved="dataSaved()"
            @data-updated="dataUpdated()"
          />
        </v-dialog>

        <v-dialog v-model="bulkDelete" width="600" persistent>
          <v-card>
            <v-card-title
              :style="{'background-color':getThemeColor,'color':'white'}"
              class="headline lighten-2"
            >Delete Selected {{selectedTable | capitalize}} items</v-card-title>
            <v-card-title
              class="mt-6 mx-4"
            >Number of Selected {{selectedTable | capitalize}} items: {{selectedTableItems.length}}</v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn rounded color="error" dark @click="deleteBulkNow()">Delete Now</v-btn>
              <v-btn rounded color="primary" dark @click="cancelBulkDelete()">Cancel</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <Loader />
        <VueHtml2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Payment-Receipt"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="100%"
          ref="html2Pdf"
        >
          <template v-slot:pdf-content>
            <section>
              <v-card-title class="mx-4" v-if="printMode">{{selectedTable.toUpperCase()}}</v-card-title>
              <v-data-table
                loading-text="Fetching Data"
                :search="search"
                :headers="tableHeader"
                :items="tableRows"
                :items-per-page="10"
                class="elevation-1 mx-4"
              >
                <template v-slot:item.selection="{item}">
                  <v-checkbox
                    v-if="isAdmin && !printMode"
                    class="shrink"
                    @change="getSelections()"
                    :value="item.id"
                    v-model="selectedTableItems"
                  ></v-checkbox>
                </template>
                <template v-slot:item.id="{item}">
                  <v-icon @click="editTableItem(item)" v-if="isAdmin">mdi-pencil</v-icon>

                  <v-icon @click="deleteTableItem(item)" v-if="isAdmin">mdi-delete</v-icon>
                  <div
                    v-else-if="(selectedTable == 'live_lessons' || selectedTable == 'subjects') && isStaff"
                  >
                    <v-icon @click="editTableItem(item)">mdi-pencil</v-icon>
                    <v-icon @click="deleteTableItem(item)">mdi-delete</v-icon>
                  </div>

                  <v-btn
                    v-for="(rtable,rind) in relatedTables"
                    :key="rind+Math.random()+Math.random()"
                    :color="btnColors[rind]"
                    class="mx-1"
                    rounded
                    x-small
                    dark
                    @click="showRelTable(rtable,item)"
                  >{{rtable}}</v-btn>

                  <v-btn
                    v-if="(selectedTable == 'live_lessons' || selectedTable == 'subjects')"
                    color="green accent-4"
                    class="mx-1"
                    rounded
                    x-small
                    dark
                    @click="joinLiveLesson(item)"
                  >Join Now</v-btn>
                </template>
              </v-data-table>
            </section>
          </template>
        </VueHtml2pdf>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "@/plugins/axios";
import Loader from "@/components/Loader.vue";
import TableDialog from "@/components/myLibrary/TableDialog.vue";
import DatabaseEntryForm from "@/components/myLibrary/DatabaseEntryForm.vue";
import VueHtml2pdf from "vue-html2pdf";

export default {
  props: ["tables"],
  mounted() {
    this.filteredTables = this.tables.filter(tabl => {
      return tabl.alevel.includes(Number(this.getCurrentUser.alevel));
    });

    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/initialise-income-and-expense-cats", this.getAccessToken)
      .then(() => {
        
        this.$store.commit("setLoader", false);
      });
  },
  updated() {
    this.printMode = false;
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },

    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getCurrentDate() {
      return axios.getCurrentDate();
    }
  },

  components: {
    Loader,
    TableDialog,
    DatabaseEntryForm,
    VueHtml2pdf
  },
  data() {
    return {
      printMode: false,
      queryFilter: "1=1",
      queryColumn0: null,
      queryCondition0: null,
      queryValue0: null,
      queryJoinOperator0: null,
      queryJoinOperator1: null,
      queryJoinOperator2: null,
      queryColumn1: null,
      queryCondition1: null,
      queryValue1: null,
      queryColumn2: null,
      queryCondition2: null,
      queryValue2: null,
      queryColumn3: null,
      queryCondition3: null,
      queryValue3: null,

      queryConditions: [
        { text: "Equal To", value: "=" },
        { text: "Greater Than", value: ">" },
        { text: "Less Than", value: "<" },
        { text: "Greater Than or Equal To", value: ">=" },
        { text: "Less Than or Equal To", value: "<=" },
        { text: "Not Equal To", value: "<>" },
        { text: "Contains", value: "like" }
      ],
      filteredTables: [],
      pdf: "",
      status: null,
      selectedTable: null,
      selectedTableItems: [],
      showColumns: false,
      tableHeader: [],
      tempTableHeaders: [],
      tableRows: [],
      showTable: false,
      selectAll: false,
      search: "",
      dialog: false,
      bulkDelete: false,
      dialogItem: false,
      dialogRels: false,
      dropdownItems: [],
      selCols: [],
      colData: [],
      selData: [],
      entryEditData: {},
      tblHeaders: [],
      saveFormDataPackage: [],
      relatedTables: [],
      tableData: [],
      finalTblData: [],
      selTable: null,
      btnColors: [
        "#3dc7be",
        "indigo darken-4",
        "amber darken-4",
        "blue-grey darken-4",
        "orange accent-4",
        "yellow accent-4",
        "light-green accent-4",
        "pink darken-3"
      ]
    };
  },
  methods: {
    printModeClosed() {
      this.tableHeader.unshift(this.tempTableHeaders[0]);
      this.tableHeader.push(this.tempTableHeaders[1]);
      this.printMode = false;
    },
    generateReport() {
      this.tempTableHeaders.push(this.tableHeader[0]);
      this.tempTableHeaders.push(this.tableHeader[this.tableHeader.length - 1]);
      this.tableHeader.pop();
      this.tableHeader.shift();
      this.printMode = true;
      this.$refs.html2Pdf.generatePdf();
    },

    openBulkDeleteDialog() {
      if (this.selectedTableItems.length < 1) {
        alert("You Must Select At least One(1) Item!");
        event.preventDefault();
      } else {
        this.bulkDelete = true;
      }
    },
    openExpensesReceipts() {
      if (this.selectedTableItems.length < 1) {
        alert("You Must Select At least One(1) Item!");
        event.preventDefault();
      } else {
        this.$router.push({
          name: "expense-receipts",
          params: { ids: this.selectedTableItems }
        });
      }
    },
    deleteBulkNow() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/bulk-delete",
          { table: this.selectedTable, rowIds: this.selectedTableItems },
          this.getAccessToken
        )
        .then(response => {
          if (response == "success") {
            this.$store.commit("setLoader", false);
            this.bulkDelete = false;
            this.getSelectedColumns();
            this.selectedTableItems = [];
          }
        });
    },
    cancelBulkDelete() {
      this.selectedTableItems = [];
      this.bulkDelete = false;
    },
    dataSaved() {
      this.snackBarText = "Data Saved Successfully";
      this.snackBar = true;
      setTimeout(this.closeDialogItem, 2000);
    },
    dataUpdated() {
      this.snackBarText = "Data Updated Successfully";
      this.snackBar = true;
      setTimeout(() => {
        this.snackBar = false;
      }, 2000);
    },
    showRelTable(rtable, item) {
      this.selTable = rtable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.selData = [item];
      this.getDropdownItems(this.selTable);
    },
    showBulk() {
      this.$store.commit("setLoader", true);
      this.selTable = this.selectedTable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.selData = this.tableRows;
      this.getDropdownItems(this.selTable);
    },
    getDropdownItems(table) {
      axios
        .postDataWithToken(
          "/auth/get-dependent-table-columns",
          { table: table },
          this.getAccessToken
        )
        .then(response => {
          this.$store.commit("setLoader", false);
          this.dropdownItems = response;
          this.dialog = true;
        });
    },
    enterData() {
      this.selTable = this.selectedTable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.getDropdownItemsForm(this.selTable);
      this.entryEditData = {};
      this.dialogItem = true;
      this.status = "new";
    },
    closeDialogItem() {
      this.dialogItem = false;
      this.getSelectedColumns();
    },
    deleteTableItem(item) {
      if (confirm("Are you sure you want to delete this item?")) {
        axios
          .postDataWithToken(
            "/auth/delete-item",
            { table: this.selectedTable, id: item.id },
            this.getAccessToken
          )
          .then(() => this.getSelectedColumns());
      }
    },
    prepareQueryFilters() {
      this.queryFilter = "";
      for (let i = 0; i < 4; i++) {
        if (
          this["queryColumn" + i] != null &&
          this["queryCondition" + i] != null &&
          this["queryValue" + i] != null
        ) {
          if (this["queryCondition" + i] == "Contains") {
            this.queryFilter += `${this["queryColumn" + i]} LIKE '%${
              this["queryValue" + i]
            }%'`;
          } else {
            this.queryFilter += `${eval(
              "this" + "." + "queryColumn" + i
            )} ${eval("this" + "." + "queryCondition" + i)} '${eval(
              "this" + "." + "queryValue" + i
            )}'`;
          }

          if (i < 3 && this["queryJoinOperator" + i] != null) {
            this.queryFilter += ` ${this["queryJoinOperator" + i]} `;
          } else {
            continue;
          }
        } else {
          continue;
        }
      }

      this.dialog = false;
    },
    resetVariables() {
      this.queryFilter = "1=1";
    },
    getSelectedColumns() {
      this.$store.commit("setLoader", true);

      this.showColumns = false;
      this.showTable = true;
      this.tableHeader = [{ value: "selection" }];

      this.finalTblData.forEach(colD => {
        this.tableHeader.push({
          text: colD.colAppearanceText,
          value: colD.retrievalKey
        });
      });
      this.tableHeader.push({ text: "Actions", value: "id" });
      axios
        .postDataWithToken(
          "/auth/get-table-columns",
          { table: this.selectedTable, queryFilter: this.queryFilter },
          this.getAccessToken
        )
        .then(response => {
          this.$store.commit("setLoader", false);
          this.tableRows = response;
          if (this.showTable) {
            this.queryFilter = "1=1";
            this.generateReport();
          }
        });
    },
    getDropdownItemsForm(table) {
      axios
        .postDataWithToken(
          "/auth/get-dependent-table-columns",
          { table: table },
          this.getAccessToken
        )
        .then(response => {
          this.$store.commit("setLoader", false);
          this.dropdownItems = response;
          this.dialogItem = true;
        });
    },

    editTableItem(item) {
      this.selTable = this.selectedTable;
      this.tblHeaders = this.getTableDialogCols(this.selTable);
      this.getDropdownItemsForm(this.selTable);
      this.entryEditData = item;
      this.dialogItem = true;
      this.status = "edit";
    },

    closeDialog() {
      this.dialog = false;
      this.getSelectedColumns();
    },

    getColumns() {
      this.finalTblData = [];
      this.colData = [];
      this.$store.commit("setLoader", false);
      axios
        .postDataWithToken(
          "/auth/get-table-column",
          { table: this.selectedTable },
          this.getAccessToken
        )
        .then(response => {
          this.showColumns = true;
          this.showTable = false;
          this.tableData = [];
          this.relatedTables = [];

          const keyValuePairs = Object.entries(response);

          keyValuePairs.forEach(columnData => {
            if (columnData[0] == "id" || columnData[0] == "emis") {
              return;
            } else if (
              columnData[1] != null &&
              typeof columnData[1] == "object"
            ) {
              const tbl = columnData[0];
              this.relatedTables.push(tbl);
              const columns = Object.keys(columnData[1]);
              columns.forEach(column => {
                if (column == "id" || column == "emis") {
                  return;
                }
                const colspace = column.replace("_", " ");
                this.tableData.push({
                  table: tbl,
                  column: column,
                  colAppearanceText: colspace.toUpperCase(),
                  retrievalKey: tbl + "." + column,
                  tableId: tbl + ".id"
                });
              });
            } else {
              const tbl = this.selectedTable;
              const column = columnData[0];
              const colspace = column.replace("_", " ");
              this.tableData.push({
                table: tbl,
                column: column,
                colAppearanceText: colspace.toUpperCase(),
                retrievalKey: column,
                tableId: tbl + ".id"
              });
            }
          });

          this.finalTblData = this.tableData;
          this.$store.commit("setLoader", false);
        });
    },

    getTableDialogCols(selTable) {
      axios
        .postDataWithToken(
          "/auth/get-columns",
          { table: selTable },
          this.getAccessToken
        )
        .then(response => {
          this.tblHeaders = response;
          this.tblHeaders.splice(this.tblHeaders.indexOf("id"), 1);
          this.tblHeaders.splice(this.tblHeaders.indexOf("emis"), 1);
        });
    },
    selectAllTableItems() {
      if (this.selectAll) {
        this.selectedTableItems = [];
        this.tableRows.forEach(row => {
          this.selectedTableItems.push(row.id);
        });
      } else {
        this.selectedTableItems = [];
      }
    },
    getTableData(table) {
      this.selectedTable = table;
      this.getColumns();
    },
    joinLiveLesson(item) {
      this.$router.push({ name: "live-videos", params: { lesson: item } });
    }
  },
  filters: {
    capitalize(item) {
      return item.toUpperCase();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>